// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how {
  background: #fff;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  padding: 72px 20px;
}

.how-inner {
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
}

.how-head { margin-bottom: 52px; }

.how-steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  position: relative;
}

.how-steps::before {
  content: '';
  position: absolute;
  top: 28px;
  left: calc(16.6% + 16px);
  width: calc(66.7% - 32px);
  height: 2px;
  background: repeating-linear-gradient(90deg, var(--p1) 0, var(--p1) 8px, transparent 8px, transparent 18px);
  opacity: 0.3;
}

.how-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 0 12px;
}

.how-num {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--grad);
  color: #fff;
  font-size: 1.2rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 16px rgba(79,70,229,0.28);
}

.how-step-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);
}

.how-step-desc {
  font-size: 0.88rem;
  color: var(--muted);
  line-height: 1.6;
}

.how-cta {
  margin-top: 44px;
}

@media (max-width: 640px) {
  .how-steps { grid-template-columns: 1fr; gap: 28px; }
  .how-steps::before { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/HowItWorks.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,YAAY,mBAAmB,EAAE;;AAEjC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,yBAAyB;EACzB,WAAW;EACX,2GAA2G;EAC3G,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa,0BAA0B,EAAE,SAAS,EAAE;EACpD,qBAAqB,aAAa,EAAE;AACtC","sourcesContent":[".how {\n  background: #fff;\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  padding: 72px 20px;\n}\n\n.how-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.how-head { margin-bottom: 52px; }\n\n.how-steps {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n  position: relative;\n}\n\n.how-steps::before {\n  content: '';\n  position: absolute;\n  top: 28px;\n  left: calc(16.6% + 16px);\n  width: calc(66.7% - 32px);\n  height: 2px;\n  background: repeating-linear-gradient(90deg, var(--p1) 0, var(--p1) 8px, transparent 8px, transparent 18px);\n  opacity: 0.3;\n}\n\n.how-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding: 0 12px;\n}\n\n.how-num {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--grad);\n  color: #fff;\n  font-size: 1.2rem;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 4px 16px rgba(79,70,229,0.28);\n}\n\n.how-step-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.how-step-desc {\n  font-size: 0.88rem;\n  color: var(--muted);\n  line-height: 1.6;\n}\n\n.how-cta {\n  margin-top: 44px;\n}\n\n@media (max-width: 640px) {\n  .how-steps { grid-template-columns: 1fr; gap: 28px; }\n  .how-steps::before { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
